module.exports = __webpack_public_path__ + "img/correct.add6312b.jpg";